import Card from "react-bootstrap/Card"
import Placeholder from "react-bootstrap/Placeholder"

export default function TextBlockHolder() {
    return (
        <div className="d-flex justify-content-around">
            <Card className="card h-100" style={{ width: "100%" }}>
                <Card.Body>
                    <Placeholder
                        as={Card.Text}
                        animation="glow"
                        className="text-start"
                    >
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={7} /> <Placeholder xs={4} />{" "}
                        <Placeholder xs={4} /> <Placeholder xs={6} />{" "}
                        <Placeholder xs={8} />
                    </Placeholder>
                </Card.Body>
            </Card>
        </div>
    )
}
